const moduleRect = {
  state: {
    rect_list: [],
    rect_options: {
      minw: 300,
      minh: 300
    },
    routes_list: [],
    map_options_list: []
  },
  mutations: {
    /* Блок */
    RECT_ADD(state, data) {
      state.rect_list.push(data)
    },
    RECT_UPDATE(state, data) {
      const itemIndex = state.rect_list.findIndex(i => i.rect_id == data.rect_id)
      if (itemIndex !== -1) {
        state.rect_list.splice(itemIndex, 1, data)
      }
    },
    RECT_REMOVE(state, rect_id) {
      state.rect_list = state.rect_list.filter(i => i.rect_id != rect_id)
      // Удаление всех маршрутов закрепленных за удаляемым блоком
      state.routes_list = state.routes_list.filter(i => i.rect_id != rect_id)
      // Удалении опций карты закрепленной за удаляемым блоком
      state.map_options_list = state.map_options_list.filter(i => i.rect_id != rect_id)
    },
    /* Блок END */

    /* Маршрурты для блока */
    RECT_ROUTES_ADD(state, data) {
      state.routes_list.push(data)
    },
    RECT_ROUTES_REMOVE(state, { route_and_type, rect_id }) {
      const itemIndex = state.routes_list.findIndex(i => i.route_and_type == route_and_type && i.rect_id == rect_id)
      if (itemIndex !== -1) {
        state.routes_list.splice(itemIndex, 1)
      }
    },
    /* Маршрурты для блока END */

    /* Настройки и состояние карты */
    RECT_MAP_OPTIONS_ADD(state, data) {
      state.map_options_list.push(data)
    },
    RECT_MAP_OPTIONS_UPDATE(state, data) {
      const itemIndex = state.map_options_list.findIndex(i => i.rect_id == data.rect_id)
      if (itemIndex !== -1) {
        state.map_options_list.splice(itemIndex, 1, data)
      }
    },
    RECT_MAP_OPTIONS_REMOVE(state, rect_id) {
      state.map_options_list = state.map_options_list.filter(i => i.rect_id != rect_id)
    },
    /* Настройки и состояние карты END */

    RECT_RESET_ALL_STATE(state) {
      state.rect_list = []
      state.routes_list = []
      state.map_options_list = []
    }
  },
  actions: {},
  getters: {
    RECT_LIST: state => state.rect_list,
    RECT_BY_ID: state => rect_id => state.rect_list.find(i => i.rect_id == rect_id),
    RECT_OPTIONS: state => state.rect_options,
    RECT_ROUTES_LIST: state => state.routes_list,
    RECT_ROUTES_LIST_COUNT: state => rect_id => state.routes_list.filter(i => i.rect_id == rect_id).length,
    RECT_ROUTES_BY_RECT_ID: state => rect_id => state.routes_list.filter(i => i.rect_id == rect_id),
    RECT_MAP_OPTIONS_BY_RECT_ID: state => rect_id => state.map_options_list.find(i => i.rect_id == rect_id),
  }
}
export default moduleRect